import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import { notification } from 'antd'
import { addDiwaliGiftPhotosUrl, getAllAgentOfMarketingUserUrl } from '../apis'

export const addDiwaliGiftPhotos = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addDiwaliGiftPhotosUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message
    })
  } else {
    notification.error({
      message: data.message || 'Error '
    })
  }
  return data
}

export const getAllAgentOfMarketingUserFxn = filters => async dispatch => {
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(getAllAgentOfMarketingUserUrl(), config)
  return data.data
}
